export enum AbnQuestion {
  BusinessDescription = "ABN_BUSINESS_DESCRIPTION",
  BusinessAddress = "ABN_BUSINESS_ADDRESS",
  BusinessActivity = "ABN_BUSINESS_ACTIVITY",
  // GST-specific questions
  BusinessGSTRegistration = "ABN_BUSINESS_GST_REGISTRATION",
  GSTTurnover = "ABN_GST_TURNOVER",
  GSTLodgementFrequency = "ABN_GST_LODGEMENT_FREQUENCY",
  GSTCashAccounting = "ABN_GST_CASH_ACCOUNTING",
  GSTImportsGoods = "ABN_GST_IMPORTS_GOODS",
  BusinessJurisdiction = "ABN_BUSINESS_JURISDICTION",
  AgriculturalOperations = "ABN_AGRICULTURAL_OPERATIONS",
}

export const ABN_FIELD_TO_PATH: Record<AbnQuestion, string> = {
  [AbnQuestion.BusinessDescription]: "business-description",
  [AbnQuestion.BusinessAddress]: "business-address",
  [AbnQuestion.BusinessActivity]: "business-activity",
  // Add paths for new questions
  [AbnQuestion.BusinessGSTRegistration]: "business-gst-registration",
  [AbnQuestion.GSTTurnover]: "gst-turnover",
  [AbnQuestion.GSTLodgementFrequency]: "gst-lodgement-frequency",
  [AbnQuestion.GSTCashAccounting]: "gst-cash-accounting",
  [AbnQuestion.GSTImportsGoods]: "gst-imports-goods",
  [AbnQuestion.BusinessJurisdiction]: "business-jurisdiction",
  [AbnQuestion.AgriculturalOperations]: "agricultural-operations",
};
